
//const videourl = "http://api.evolve.de/evolvedemopage/api/public/videos";
const videourl = "https://api.evolvejobs.de/demo/api/public/videos";
export default videourl;